export default "__VITE_PUBLIC_ASSET__16986ad7__"